import type { ReactNode } from 'react';

export type PillVariant = 'ok' | 'warn' | 'danger' | 'muted' | 'indigo' | 'rose' | 'teal';

interface StatusPillProps {
  variant: PillVariant;
  children: ReactNode;
  /** Show the little leading dot (on by default). */
  dot?: boolean;
}

/** Small rounded status label in the palette's tint colours. */
export default function StatusPill({ variant, children, dot = true }: StatusPillProps) {
  return (
    <span className={`pill pill--${variant}`}>
      {dot && <span className="pill__dot" />}
      {children}
    </span>
  );
}

/** Map common domain statuses to pill variants + labels, so pages agree. */
export const DOC_STATUS_PILL: Record<string, { variant: PillVariant; label: string }> = {
  ok: { variant: 'ok', label: 'In place' },
  'needs-update': { variant: 'warn', label: 'Needs update' },
  missing: { variant: 'danger', label: 'Missing' },
};

export const CASE_STATUS_PILL: Record<string, { variant: PillVariant; label: string }> = {
  open: { variant: 'indigo', label: 'In progress' },
  waiting: { variant: 'muted', label: 'Waiting' },
  escalated: { variant: 'rose', label: 'With expert' },
  resolved: { variant: 'ok', label: 'Resolved' },
};
